export default __webpack_public_path__ + "f9bf889d198e6f31a8030e5102c70e51.woff2";